<template>
  <q-btn
    icon="slideshow"
    round
  >
    <q-tooltip>Support Videos</q-tooltip>
    <q-menu
      bordered
      side="right"
      overlay
    >
      <q-list>
        <q-item
          v-for="supportVideo in videos"
          :key="supportVideo.youtubeSlug"
          clickable
          @click="playVideo(supportVideo.youtubeSlug)"
        >
          <q-item-section thumbnail>
            <img :src="'https://img.youtube.com/vi/' + supportVideo.youtubeSlug + '/0.jpg'">
          </q-item-section>
          <q-item-section>
            {{ supportVideo.title }}
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
    <q-dialog
      v-model="showFullScreenVideo"
      full-width
    >
      <q-video
        style="width: 100%"
        :ratio="16/9"
        :src="'https://www.youtube.com/embed/' + youtubeSlug"
      />
    </q-dialog>
  </q-btn>
</template>

<script>
import { categories } from 'src/modules/admin/support/Support'

export default {
  name: 'SupportMenu',
  props: {
    category: {
      type: String,
      required: false,
      default: null
    },
    video: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      showFullScreenVideo: false,
      youtubeSlug: null
    }
  },
  computed: {
    videos () {
      if (this.category) {
        return _.find(categories, { title: this.category }).videos
      } else if (this.video) {
        return [_(categories).map('videos').flatten().find({ title: this.video })]
      } else {
        throw new Error('Must provide catogory or video name')
      }
    }
  },
  methods: {
    playVideo (slug) {
      this.showFullScreenVideo = true
      this.youtubeSlug = slug
    }
  }
}
</script>
